// extracted by mini-css-extract-plugin
export default {"view":"QuestionBankView_view__LFD5Q"};